import {useMutation, useQuery, useQueryClient} from "react-query";
import {getClientsWithoutWhatsapp, postClientWithoutWhatsapp} from "./api";

export const useClientsWithoutWhatsapp = (page) => {
    return useQuery(
        ['clientsWithoutWhatsapp', page],
        () => getClientsWithoutWhatsapp(page).then(res => res.data),
        {
            keepPreviousData: true,
        }
    );
};

export const usePostClientWithoutWhatsapp = () => {
    const queryClient = useQueryClient();

    return useMutation(
        (phone) => postClientWithoutWhatsapp(phone),
        {
            onSuccess: () => {
                queryClient.invalidateQueries('clientsWithoutWhatsapp');
            },
        }
    );
};
